// Account states as reported by the backend (models.Status* in Go).

export const ACCOUNT_STATUS = {
  ACTIVE: 'active',
  EMAIL_UNVERIFIED: 'email_unverified',
  PENDING_ACTIVATION: 'pending_activation',
  SUBSCRIPTION_EXPIRED: 'subscription_expired',
  BLOCKED: 'blocked',
};

// Short labels for the admin users table.
export const STATUS_LABELS = {
  [ACCOUNT_STATUS.ACTIVE]: 'Активен',
  [ACCOUNT_STATUS.EMAIL_UNVERIFIED]: 'Почта не подтверждена',
  [ACCOUNT_STATUS.PENDING_ACTIVATION]: 'Ожидает активации',
  [ACCOUNT_STATUS.SUBSCRIPTION_EXPIRED]: 'Подписка истекла',
  [ACCOUNT_STATUS.BLOCKED]: 'Заблокирован',
};

export const STATUS_COLORS = {
  [ACCOUNT_STATUS.ACTIVE]: 'success',
  [ACCOUNT_STATUS.EMAIL_UNVERIFIED]: 'default',
  [ACCOUNT_STATUS.PENDING_ACTIVATION]: 'warning',
  [ACCOUNT_STATUS.SUBSCRIPTION_EXPIRED]: 'error',
  [ACCOUNT_STATUS.BLOCKED]: 'error',
};

// What a person is to the business (the type in the administrator's list). It is worked out from
// the data, and an administrator can set it by hand. It is a label: access is the subscription.
export const ACCOUNT_TYPE_LABELS = {
  user: 'Пользователь',
  seller: 'Селлер',
  agent: 'Агент',
  seller_agent: 'Селлер · Агент',
};

// Explanation shown on the login page when a sign-in is refused.
export function loginDenialMessage(reason, supportContact) {
  const contact = supportContact ? ` Свяжитесь с администратором: ${supportContact}` : ' Свяжитесь с администратором.';

  switch (reason) {
    case ACCOUNT_STATUS.EMAIL_UNVERIFIED:
      return 'Почта не подтверждена. Войдите и введите код из письма, которое мы отправили при регистрации.';
    case ACCOUNT_STATUS.PENDING_ACTIVATION:
      return `Регистрация завершена, но доступ ещё не открыт.${contact}`;
    case ACCOUNT_STATUS.SUBSCRIPTION_EXPIRED:
      return `Срок подписки истёк. Для продления доступа${contact}`;
    case ACCOUNT_STATUS.BLOCKED:
      return `Аккаунт заблокирован.${contact}`;
    default:
      return null;
  }
}
